import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingRCSActions from "../actions/account_campaign_pricing_rcs_actions";
import * as accountCampaignPricingRCSTypes from "../types/account_campaign_pricing_rcs_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountRCSCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_RCS}/${action.payload.id}`, action.payload);
    if (res.status === 200) {
      yield put(accountCampaignPricingRCSActions.getPricingOfAccountRCSCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingRCSActions.getPricingOfAccountRCSCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingRCSActions.getPricingOfAccountRCSCampaignError(e));
  }
}

function* editPricingOfAccountRCSCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_RCS}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingRCSActions.editPricingOfAccountRCSCampaignSuccess(res.data));
      yield put(accountCampaignPricingRCSActions.getPricingOfAccountRCSCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingRCSActions.editPricingOfAccountRCSCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingRCSActions.editPricingOfAccountRCSCampaignError(e));
  }
}
export default function* accountCampaignPricingRCSSaga() {
  yield takeLatest(accountCampaignPricingRCSTypes.getPricingOfAccountRCSCampaign.REQUEST, getPricingOfAccountRCSCampaign);
  yield takeLatest(accountCampaignPricingRCSTypes.editPricingOfAccountRCSCampaign.REQUEST, editPricingOfAccountRCSCampaign);
}
